/* CARAVIUM DESTINATION PLACES MODULE V2 — richer fichas */
(() => {
  "use strict";

  const ROOT_ID = 'caravium-area-ficha';
  const SUPABASE_URL = 'https://ouhtkmpgsmauyebwpqsj.supabase.co';
  const SUPABASE_KEY = 'sb_publishable_CBwe_LRkZmEii18EiiUtuA_uxonULzb';
  const DESKTOP_BANNER_URL = 'https://cdn.shopify.com/s/files/1/1032/3086/5785/files/bannercaravium.png?v=1787655666';
  const FALLBACK_SVG = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="1280" height="720" viewBox="0 0 1280 720">
      <defs><linearGradient id="g" x1="0" x2="1" y1="0" y2="1"><stop stop-color="#123B5D" offset="0"/><stop stop-color="#20B9AA" offset="1"/></linearGradient></defs>
      <rect width="1280" height="720" fill="url(#g)"/><circle cx="1080" cy="120" r="190" fill="#fff" fill-opacity="0.08"/>
      <path d="M70 590 C190 450 330 490 390 535 C450 430 575 450 630 520 C730 415 860 455 925 520 C1030 445 1120 485 1215 585 L1215 660 L70 660 Z" fill="#fff" fill-opacity="0.14"/>
      <text x="70" y="630" font-family="Arial" font-size="52" font-weight="700" fill="#fff">CARAVIUM</text>
    </svg>`
  );

  const headers = { apikey: SUPABASE_KEY, Authorization: `Bearer ${SUPABASE_KEY}`, 'Content-Type': 'application/json' };
  const esc = (v) => String(v ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[c]));

  const apiGet = async (path) => {
    try {
      const r = await fetch(`${SUPABASE_URL}/rest/v1/${path}`, { headers });
      if (!r.ok) { console.warn('CARAVIUM destination places Supabase response:', r.status, path); return null; }
      return await r.json();
    } catch (err) { console.warn('CARAVIUM destination places Supabase read failed safely:', err); return null; }
  };

  const destinationSection = () => document.getElementById(ROOT_ID)?.querySelector('section.cv-destination-section') || null;

  const waitForDestinationSection = async (timeoutMs = 10000) => {
    const started = Date.now();
    while (Date.now() - started < timeoutMs) {
      const section = destinationSection();
      if (section) return section;
      await new Promise(resolve => setTimeout(resolve, 200));
    }
    return null;
  };

  const findSpot = async (spotId) => {
    const rows = await apiGet(`spots?id=eq.${encodeURIComponent(spotId)}&select=id,municipio,provincia&limit=1`);
    return Array.isArray(rows) && rows.length ? rows[0] : null;
  };

  const findDestination = async (spot) => {
    if (!spot?.municipio) return null;
    const municipio = encodeURIComponent(spot.municipio);
    const fields = 'id,municipio,provincia,slug,cover_image_url,cover_image_source,cover_image_license,seo_title,seo_description';
    let path = `destinations?municipio=ilike.${municipio}`;
    path += spot.provincia ? `&provincia=ilike.${encodeURIComponent(spot.provincia)}` : '&provincia=is.null';
    path += `&select=${fields}&limit=1`;
    let rows = await apiGet(path);
    if ((!Array.isArray(rows) || !rows.length) && spot.municipio) {
      rows = await apiGet(`destinations?municipio=ilike.${municipio}&select=${fields}&limit=1`);
    }
    return Array.isArray(rows) && rows.length ? rows[0] : null;
  };

  const findDestinationPlaces = async (destinationId) => {
    if (!destinationId) return [];
    const rows = await apiGet(`destination_places?destination_id=eq.${encodeURIComponent(destinationId)}&active=eq.true&select=*&order=sort_order.asc`);
    return Array.isArray(rows) ? rows : [];
  };

  const ensureStyles = () => {
    if (document.getElementById('cv-destination-v2-style')) return;
    const style = document.createElement('style');
    style.id = 'cv-destination-v2-style';
    style.textContent = `
      .cv-destination-cover{margin:0 0 28px;border-radius:24px;overflow:hidden;border:1px solid #dce6ea;background:#eef3f5;box-shadow:0 14px 34px rgba(18,59,93,.10)}
      .cv-destination-cover-media{position:relative;aspect-ratio:16/7;min-height:280px;background:#123b5d;overflow:hidden}
      .cv-destination-cover-media img{width:100%;height:100%;display:block;object-fit:cover;object-position:center}
      .cv-destination-cover-shade{position:absolute;inset:auto 0 0 0;padding:52px 26px 22px;background:linear-gradient(transparent,rgba(7,27,43,.82));color:#fff}
      .cv-destination-cover-kicker{font-size:11px;font-weight:900;letter-spacing:.1em;color:#7df0e2;margin-bottom:5px;text-transform:uppercase}
      .cv-destination-cover-title{margin:0;color:#fff;font-size:clamp(24px,3.1vw,40px);line-height:1.05;text-shadow:0 2px 9px rgba(0,0,0,.22)}
      .cv-destination-cover-caption{display:flex;justify-content:space-between;gap:14px;align-items:center;padding:10px 14px;background:#fff;color:#687985;font-size:11px;line-height:1.4}
      .cv-destination-cover-caption a{color:#087f8c;text-decoration:none;font-weight:700}.cv-destination-cover-caption strong{color:#123b5d}
      .cv-destination-note{white-space:nowrap;padding:5px 9px;border-radius:999px;background:#eff9f8;color:#087f8c;font-weight:800}
      .cv-quever-section{margin-bottom:30px}.cv-quever-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:18px}
      .cv-quever-card{overflow:hidden;border:1px solid #dce6ea;border-radius:20px;background:#fff;box-shadow:0 8px 22px rgba(13,27,42,.055)}
      .cv-quever-image-wrap{aspect-ratio:16/9;overflow:hidden;background:#edf3f4}.cv-quever-image{display:block;width:100%;height:100%;object-fit:cover;transition:transform .25s ease}
      .cv-quever-card:hover .cv-quever-image{transform:scale(1.025)}.cv-quever-content{padding:18px}.cv-quever-title{margin:0 0 8px;color:#123b5d;font-size:20px}.cv-quever-copy{margin:0 0 14px;color:#566b79;line-height:1.55}
      .cv-quever-actions{margin-top:14px}.cv-quever-link{display:inline-flex;align-items:center;justify-content:center;min-height:42px;padding:9px 13px;border-radius:11px;background:#16b8aa;color:#fff!important;text-decoration:none;font-weight:900}
      .cv-quever-source{margin-top:12px;color:#81909a;font-size:10px;line-height:1.35}.cv-quever-source-link{color:#738691!important;text-decoration:none}
      .cv-destination-content-title{margin:28px 0 14px}.cv-destination-content-title h2{margin:0;color:#123b5d}
      @media(max-width:820px){.cv-destination-cover{border-radius:18px;margin-bottom:20px}.cv-destination-cover-media{aspect-ratio:4/3;min-height:0}.cv-destination-cover-shade{padding:42px 17px 16px}.cv-destination-cover-caption{display:block}.cv-destination-note{display:inline-flex;margin-top:7px}.cv-quever-grid{grid-template-columns:1fr}.cv-quever-card{border-radius:17px}.cv-quever-content{padding:16px}}
    `;
    document.head.appendChild(style);
  };

  const removeTextualQueVer = (section) => {
    section.querySelectorAll('article.cv-tourism-card').forEach(card => {
      if (card.querySelector('h3')?.textContent?.trim().toLowerCase() === 'qué ver') card.remove();
    });
    section.querySelectorAll('details.cv-tourism-item').forEach(item => {
      const label = item.querySelector('span.cv-tourism-summary-main span:nth-child(2)')?.textContent?.trim().toLowerCase();
      if (label === 'qué ver') item.remove();
    });
  };

  const removeDestinationGuideLabel = (section) => {
    section.querySelectorAll('*').forEach(el => {
      const text = (el.textContent || '').trim().replace(/\s+/g, ' ').toUpperCase();
      if (text === 'GUÍA DEL DESTINO' || text === 'GUIA DEL DESTINO') el.remove();
    });
  };

  const forceMobileToDesktopStyle = (section) => {
    if (!window.matchMedia('(max-width: 820px)').matches) return;
    const root = document.getElementById(ROOT_ID);
    if (!root) return;

    const banner = root.querySelector('.cv-travel-banner');
    if (banner) {
      const desktopImg = banner.querySelector('.cv-travel-banner-desktop');
      const mobileImg = banner.querySelector('.cv-travel-banner-mobile');
      if (desktopImg) {
        desktopImg.src = DESKTOP_BANNER_URL;
        desktopImg.style.setProperty('display', 'block', 'important');
        desktopImg.style.setProperty('width', '100%', 'important');
        desktopImg.style.setProperty('height', 'auto', 'important');
        desktopImg.style.setProperty('max-height', 'none', 'important');
        desktopImg.style.setProperty('object-fit', 'contain', 'important');
        desktopImg.style.setProperty('object-position', 'center', 'important');
      }
      if (mobileImg) mobileImg.remove();
      banner.style.setProperty('width', '100%', 'important');
      banner.style.setProperty('overflow', 'hidden', 'important');
    }

    removeDestinationGuideLabel(section);
    const desktopTourism = section.querySelector('.cv-tourism-desktop');
    const accordion = section.querySelector('.cv-tourism-accordion');
    if (desktopTourism) {
      desktopTourism.style.setProperty('display', 'grid', 'important');
      desktopTourism.style.setProperty('grid-template-columns', '1fr', 'important');
      desktopTourism.style.setProperty('gap', '14px', 'important');
    }
    if (accordion) accordion.style.setProperty('display', 'none', 'important');
    section.querySelectorAll('.cv-destination-paragraph').forEach((p, index, all) => {
      p.style.setProperty('margin-bottom', index === all.length - 1 ? '0' : '16px', 'important');
    });
  };

  const buildMapsUrl = (lat, lng) => Number.isFinite(lat) && Number.isFinite(lng)
    ? `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(`${lat},${lng}`)}`
    : 'https://www.google.com/maps';

  const renderDestinationCover = (section, destination) => {
    if (!section || section.querySelector('.cv-destination-cover')) return;
    ensureStyles();
    const town = esc(destination?.municipio || 'el destino');
    const province = esc(destination?.provincia || '');
    const image = esc(destination?.cover_image_url || FALLBACK_SVG);
    const source = destination?.cover_image_source || '';
    const license = esc(destination?.cover_image_license || '');
    const sourceLink = source ? `<a href="${esc(source)}" target="_blank" rel="noopener nofollow">Fuente de la imagen</a>` : '';
    const figure = document.createElement('figure');
    figure.className = 'cv-destination-cover';
    figure.innerHTML = `
      <div class="cv-destination-cover-media">
        <img src="${image}" alt="Entorno de ${town}${province ? `, ${province}` : ''} para viajar en autocaravana, camper o caravana" loading="lazy" referrerpolicy="no-referrer">
        <div class="cv-destination-cover-shade">
          <div class="cv-destination-cover-kicker">DESCUBRE EL ENTORNO</div>
          <h2 class="cv-destination-cover-title">${town}${province ? ` · ${province}` : ''}</h2>
        </div>
      </div>
      <figcaption class="cv-destination-cover-caption">
        <span><strong>Imagen del entorno</strong>${license ? ` · ${license}` : ''}${sourceLink ? ` · ${sourceLink}` : ''}</span>
        <span class="cv-destination-note">No es una foto del área</span>
      </figcaption>`;
    const img = figure.querySelector('img');
    img?.addEventListener('error', () => { if (img.dataset.cvFallbackApplied !== '1') { img.dataset.cvFallbackApplied = '1'; img.src = FALLBACK_SVG; } }, { once:true });
    section.prepend(figure);
  };

  const renderCards = (section, rows, destination) => {
    if (!Array.isArray(rows) || !rows.length || !section || section.querySelector('.cv-quever-section')) return;
    ensureStyles();
    removeTextualQueVer(section);
    removeDestinationGuideLabel(section);
    const destinationName = esc(destination?.municipio || 'el destino');

    const html = `<section class="cv-quever-section">
      <div class="cv-section-head"><div><h2>Qué ver cerca de ${destinationName}</h2></div></div>
      <div class="cv-quever-grid">
        ${rows.map(row => {
          const name = esc(row.name || 'Lugar recomendado');
          const description = esc(row.description || 'Lugar de interés para completar tu parada y descubrir el entorno.');
          const author = esc(row.image_author || '');
          const license = esc(row.image_license || '');
          const imageUrl = esc(row.image_url || FALLBACK_SVG);
          const sourceUrl = row.source_url || row.image_source || '';
          const mapsUrl = buildMapsUrl(Number(row.lat), Number(row.lng));
          const credit = [author, license].filter(Boolean).join(' · ');
          const sourceHtml = sourceUrl
            ? `<a class="cv-quever-source-link" href="${esc(sourceUrl)}" target="_blank" rel="noopener nofollow">${credit || 'Fuente de la imagen'}</a>`
            : `<span class="cv-quever-source-link">${credit}</span>`;
          return `<article class="cv-quever-card">
            <div class="cv-quever-image-wrap"><img class="cv-quever-image" src="${imageUrl}" alt="${name} cerca de ${destinationName}" loading="lazy" referrerpolicy="no-referrer"></div>
            <div class="cv-quever-content">
              <h3 class="cv-quever-title">${name}</h3><p class="cv-quever-copy">${description}</p>
              <div class="cv-quever-actions"><a class="cv-quever-link" href="${mapsUrl}" target="_blank" rel="noopener">📍 Cómo llegar</a></div>
              ${credit || sourceUrl ? `<div class="cv-quever-source">Imagen: ${sourceHtml}</div>` : ''}
            </div>
          </article>`;
        }).join('')}
      </div>
    </section>`;

    const destinationContent = section.querySelector('.cv-destination-pro');
    if (destinationContent) {
      destinationContent.insertAdjacentHTML('afterbegin', html);
      const oldHead = section.querySelector(':scope > .cv-section-head');
      if (oldHead) oldHead.remove();
      const queVer = destinationContent.querySelector('.cv-quever-section');
      queVer.insertAdjacentHTML('afterend', `<div class="cv-destination-content-title"><h2>Más sobre ${destinationName}</h2></div>`);
    } else {
      section.insertAdjacentHTML('beforeend', html);
    }

    section.querySelectorAll('.cv-quever-image').forEach(img => {
      img.addEventListener('error', () => {
        if (img.dataset.cvFallbackApplied === '1') return;
        img.dataset.cvFallbackApplied = '1';
        img.src = FALLBACK_SVG;
      }, { once: true });
    });
  };

  const boot = async () => {
    try {
      ensureStyles();
      const spotId = new URLSearchParams(window.location.search).get('id');
      if (!spotId) return;
      const spot = await findSpot(spotId);
      if (!spot) return;
      const destination = await findDestination(spot);
      if (!destination?.id) return;
      const section = await waitForDestinationSection();
      if (!section) return;

      renderDestinationCover(section, destination);
      const rows = await findDestinationPlaces(destination.id);
      if (rows.length) renderCards(section, rows, destination);
      forceMobileToDesktopStyle(section);
      setTimeout(() => forceMobileToDesktopStyle(section), 250);
      setTimeout(() => forceMobileToDesktopStyle(section), 1000);
    } catch (err) { console.warn('CARAVIUM destination places module failed safely:', err); }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
